export const DISCOUNT_COUPON_REDEMPTION = {
  NONE: "NONE",
  FIRST_PURCHASE: "FIRST_PURCHASE",
};
